import React, { useEffect, useState } from "react";
import PageLayout from "../layouts/MainLayout";
import DisciplineAllegationsTable from "../components/Regulatory/DisciplineAllegationsTable";
import DisciplineDecisionsTable from "../components/Regulatory/DisciplineDecisionsTable";

const DisciplineAppeals = () => {
  return (
    <PageLayout
      home={false}
      pageHeader={
        <>
          Discipline & Appeals
        </>
      }
    >
      <h2>Allegations</h2>
      <p>If you are interested in attending any upcoming virtual hearings, please contact <a href="/">hearings@hcraontario.ca</a>.</p>
      <DisciplineAllegationsTable />
      <h2 style={{marginTop: '50px'}}>Decisions</h2>
      <DisciplineDecisionsTable />
    </PageLayout>
  )
}

export default DisciplineAppeals;
